import { createSimpleFunctional } from '~util/helpers'

export const VAvatar = createSimpleFunctional('avatar')

export default {
  VAvatar
}



// WEBPACK FOOTER //
// ./src/components/avatars/index.js